import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import AuthorEditForm from "./EditForm/AuthorEditForm";
import CustomerEditForm from "./EditForm/CustomerEditForm";

class EditProfile extends Component {
  render() {
    return (
      <div>{this.props.isAuth ? <CustomerEditForm /> : <AuthorEditForm />}</div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.UserReducer.isAuth,
    isAuthor: state.AuthorReducer.isAuthor,
  };
};

export default connect(mapStateToProps, null)(withRouter(EditProfile));
